export const PRODUCT_LOGOS = {
  expanded: 'assets/images/logos/beyond_insite_logo_xl.svg',
  reduced: 'assets/images/logos/beyond_insite_picto.svg',
};
